function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_4207",
  "data-name": "Path 4207",
  d: "M21.2,10.837a.654.654,0,0,0-.523-.441l-5.345-.778L12.935,4.773a.651.651,0,0,0-1.168,0L9.376,9.617,4.031,10.4A.649.649,0,0,0,3.672,11.5l3.871,3.771L6.63,20.6a.649.649,0,0,0,.943.683l4.779-2.517,4.783,2.513a.626.626,0,0,0,.3.074.647.647,0,0,0,.381-.125.658.658,0,0,0,.259-.636l-.913-5.324,3.871-3.771A.644.644,0,0,0,21.2,10.837ZM16.01,14.582a.644.644,0,0,0-.186.575l.748,4.364L12.65,17.458a.66.66,0,0,0-.605,0L8.122,19.521l.748-4.364a.66.66,0,0,0-.186-.575L5.518,11.49,9.9,10.854a.651.651,0,0,0,.489-.355l1.959-3.974L14.311,10.5a.651.651,0,0,0,.489.355l4.385.636Z",
  transform: "translate(-3.475 -4.41)",
  fill: "#f6c244"
});

var SvgStar = function SvgStar(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17.752,
    height: 16.946,
    viewBox: "0 0 17.752 16.946",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStar, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/star.c246efa6.svg";
export { ForwardRef as ReactComponent };